<template>
  <div class="chosedialog">
    <el-dialog :close-on-click-modal="false" @close='send' v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao"
               append-to-body width="95%">
      <div class="h-rowIn">
        <div class="h-rowBox">
          <div class="h-rowCon yxline">
            <div class="h-piece">
              <el-form :inline="true" :model="qLd" class="demo-form-inline h-formBorder">
                <div class="h-thirdColumn w-newColumn">
                  <!--<el-form-item class="h-elformWrap-1" label="经销商">-->
                  <!--  <el-input v-model="qLd.agentName" placeholder="输入经销商/编码" disabled="true" :clearable="true"></el-input>-->
                  <!--</el-form-item>-->
                  <el-form-item label="漏斗编号" class="h-elformWrap-2" prop="username">
                    <el-input v-model="qLd.funnelCode" placeholder="输入漏斗编号" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="用户单位" class="h-elformWrap-2" prop="customerName">
                    <el-input v-model="qLd.customerName" placeholder="输入用户单位" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="渠道" prop="chanel">
                    <brselect category="sales_region" :v="qLd.customerChannel" v-model="qLd.customerChannel"
                              :clearable="true"
                              style="width:100%"/>
                  </el-form-item>
                  <el-form-item label="订单类型" prop="state">
                    <el-select v-model="qLd.ddlx" :clearable="true" @change="getLoudList">
                      <el-option label="标准订单" value="1,2">标准订单</el-option>
                      <el-option label="特价订单" value="1,11">特价订单</el-option>
                      <el-option label="套餐订单" value="1,12">套餐订单</el-option>
                      <el-option label="工程订单" value="1,1">工程订单</el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <h6 style="color: red;font-size: 0.15rem;margin-top: 0.1rem;">请在选择漏斗前请选择订单类型！</h6>
              </el-form>
              <!--展开搜素 -->
              <div class="l-screenBox">
                <div class="l-retrieval">
                  <el-button class="h-btn h-formBtn" @click="getLoudList">检索</el-button>
                  <el-button class="h-btn h-formBtn h-bgwhite" @click="restLd">重置</el-button>
                  <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="dingdadd">
                    确定
                  </el-button>
                </div>
              </div>
            </div>
            <el-table
                ref="multipleTableLd"
                :data="dataLd"
                tooltip-effect="dark"
                style="width: 100%"
                @selection-change="handleSelectionChangeLd">
              <el-table-column
                  reserve-selection
                  type="selection"
                  :selectable="selectable"
                  fixed
                  width="40">
              </el-table-column>
              <!--<el-table-column-->
              <!--    prop="agentName"-->
              <!--    label="经销商"-->
              <!--    width="140"-->
              <!--    :show-overflow-tooltip="true">-->
              <!--</el-table-column>-->
              <el-table-column
                  prop="funnelCode"
                  label="漏斗编号"
                  width="135">
              </el-table-column>
              <el-table-column
                  prop="customerName"
                  label="用户单位"
                  width="120">
              </el-table-column>
              <el-table-column
                prop="xsyb_lianqun"
                label="链群"
                width="80">
              <template slot-scope="scope">
                <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
              </template>
            </el-table-column>
              <el-table-column
                  prop="customerChannel"
                  label="渠道"
                  width="80">
                <template slot-scope="scope">
                  <dictname category="sales_region" :v="scope.row.customerChannel"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="proModel"
                  label="产品型号"
                  width="140">
              </el-table-column>
              <el-table-column
                  prop="num"
                  label="数量"
                  width="80">
              </el-table-column>
              <el-table-column
                  prop="residueNum"
                  label="剩余数量"
                  width="80">
              </el-table-column>
              <el-table-column
                  prop="price"
                  label="价格"
                  width="80">
              </el-table-column>
              <el-table-column
                  prop="totalPrice"
                  label="金额"
                  width="80">
              </el-table-column>
              <el-table-column
                  prop="proLevelOne"
                  label="产品大类"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="proLevelTwo"
                  label="产品中类"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="salesman"
                  label="销售人员"
                  :show-overflow-tooltip="true"
                  width="100">
              </el-table-column>
              <!--<el-table-column-->
              <!--    prop="statusR"-->
              <!--    label="节点"-->
              <!--    width="120">-->
              <!--  <template slot-scope="scope">-->
              <!--    <dictname category="xinxi_jiedian" :v="scope.row.statusR"/>-->
              <!--  </template>-->
              <!--</el-table-column>-->
              <!--<el-table-column-->
              <!--    prop="probjectSorts"-->
              <!--    label="项目分类"-->
              <!--    width="120">-->
              <!--  <template slot-scope="scope">-->
              <!--    <dictname category="message_type" :v="scope.row.probjectSorts"/>-->
              <!--  </template>-->
              <!--</el-table-column>-->
              <el-table-column
                  prop="expOnlineDate"
                  label="预计下单日期"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="expConvDate"
                  label="预计转换日期"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="expectConvertDate"
                  label="报单日期"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="cuname"
                  label="报单人"
                  :show-overflow-tooltip="true"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="packageCode"
                  label="套餐编号"
                  :show-overflow-tooltip="true"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="packageName"
                  label="套餐名称"
                  :show-overflow-tooltip="true"
                  width="120">
              </el-table-column>
            </el-table>
            <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
              <paginationmin :page="qLd" @query="getLoudList"/>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ss from '../../api/SystemService'
import updownfile from '../../utils/updownfile';

export default {
  name: "alluser",
  data() {
    return {
      dataLd: [],
      multipleSelectionLd: [],
      qLd: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        agentName: '',// 经销商
        agentCode: '',// 经销商编码
        funnelCode: '',//漏斗编码
        customerName: '',// 用户单位
        customerChannel: '',// 渠道
        ddlx: '', //订单类型
      },// 选择漏斗查询条件
      ttdata: null,
      lists: [],
      dailishangFlag: true,
      userRole: '',
      imgflag3: false,
    }
  },
  methods: {
    send: function () { // 向夫组件传值
      this.$refs.multipleTableLd.clearSelection();
      this.$emit('getChildValue',false)
    },

    showloudPackage() {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      if (this.order.orderCategory1 != 7 && this.order.orderCategory1 != 9 && !this.order.customerChannelCode) {
        this.$msg.msge("请先选择客户渠道！")
        return;
      }
      if (!this.order.toCompanyname) {
        this.$msg.msge("请先选择收货单位！")
        return;
      }
      this.qLd.agentName = this.order.soldToName;
      this.qLd.agentCode = this.order.soldToCode;
      this.qLd.customerChannel = this.order.customerChannelCode;
      this.qLd.ddlx = this.ddlx;
      this.qLd.customerName = this.order.toCompanyname;
      ss.OrderMainService.selectByAgent(this.qLd).then(rd => {
        this.dataLd = rd.records;
        this.qLd.total = rd.total || 0;
        this.dialogLd = true;
      })
    },

    getLoudList() {
      // this.qLd.agentCode = localStorage.getItem("userId");
      ss.OrderMainService.selectByAgent(this.qLd).then(rd => {
        this.dataLd = rd.records;
        this.qLd.total = rd.total || 0;
        //刷新 复选框
        this.$refs.multipleTableLd.clearSelection();
      })
    },
    restLd() {
      this.qLd.funnelCode = '';
      this.qLd.customerName = '';
      this.qLd.customerChannel = '';
    },
    dingdadd() {
      if (this.qLd.ddlx == '') {
        this.$message.error("请选择先订单类型！");
        return;
      }
      if (this.multipleSelectionLd.length < 1) {
        this.$message.error("请选择一条！");
        return;
      }
      if (this.qLd.ddlx == '1,2') {
        var louds = this.multipleSelectionLd
        var map = louds.map(a => a.funnelCode);
        var from = Array.from(new Set(map));
        if (from.length == 1) {
        } else {
          this.$message.error("选择标椎订单时请选择同一个漏斗编号！");
          return;
        }
      }
      if (this.qLd.ddlx == '1,11') {
        var louds = this.multipleSelectionLd
        var map = louds.map(a => a.funnelCode);
        var from = Array.from(new Set(map));
        if (from.length == 1) {
        } else {
          this.$message.error("选择特价订单时请选择同一个漏斗编号！");
          return;
        }
      }
      if (this.qLd.ddlx == '1,12') {
        var louds = this.multipleSelectionLd
        var map = louds.map(a => a.funnelCode);
        var from = Array.from(new Set(map));
        if (from.length == 1) {
        } else {
          this.$message.error("选择套餐订单时请选择同一个漏斗编号！");
          return;
        }
      }
      if (this.qLd.ddlx == '1,1') {
        var louds = this.multipleSelectionLd
        var map = louds.map(a => a.funnelCode);
        var from = Array.from(new Set(map));
        if (from.length == 1) {
        } else {
          this.$message.error("选择工程订单时请选择同一个漏斗编号！");
          return;
        }
      }
      this.$emit('getChildValue',true,this.multipleSelectionLd,this.qLd.ddlx)
    },
    handleSelectionChangeLd(val) {
        this.multipleSelectionLd = val;
    },
    selectable(row, index) {
      if(this.qLd.ddlx != ''){
        return true;
      }
      return false;
    },

    // ----------------------------

    handleFilter() {
      this.querypage();
    },
    querypage(p) {
      // if(this.q.ddlx == '1,9'){
      //     ss.wuliaoselect.selectFwPage(this.q).then(rd=>{
      //         this.q.total = rd.total;
      //         this.ttdata = rd.records;
      //
      //         // this.userRole = this._user.roles;
      //         // this.userRole.forEach((item, index) => {
      //         //     if (item.id == "swyl_dailishang") {
      //         //         this.dailishangFlag = false;
      //         //     }
      //         // })
      //     })
      // }else {
      //     ss.wuliaoselect.selectPage(this.q).then(rd=>{
      //         this.q.total = rd.total;
      //         this.ttdata = rd.records;
      //
      //         // this.userRole = this._user.roles;
      //         // this.userRole.forEach((item, index) => {
      //         //     if (item.id == "swyl_dailishang") {
      //         //         this.dailishangFlag = false;
      //         //     }
      //         // })
      //     })
      // }


    },
    handleSelectionChange(lists) {
      if (this.oneflag) {
        this.$emit('choseObj', lists[0])
      } else {
        this.lists = lists;
      }
    },
    choseSelected() {
      this.$emit('choseObj', this.lists)
    },
    downExcel() {
      updownfile.down("/api/select/wuliao/downloadExcel", this.q, "post");
    },
  },
  created() {
    // if(this.UserCode){
    //     // this.q.usercode = this.UserCode
    //     // //订单类型
    //     // this.q.ddlx = this.dingdLeix
    //     // this.q.fwddlx = this.dingdLeixFw
    //     // this.q.serviceProductsType = this.chanpLx
    //     // //项目编号
    //     // this.q.xmcode = this.xmcode
    //     // this.q.country = this.country
    //     // this.q.currencyCode = this.currencyCode
    //     // this.q.customerChannelCode = this.customerChannelCode
    //     this.querypage()
    //     //不是内部用户，都隐藏单价
    //     // if(this._user.usertype!='0'){
    //     //     this.dailishangFlag = false;
    //     // }
    // }
    this.getLoudList();
  },
  computed: {
    UserCode: function () {
      return this.usercode;
    },
    //订单类型
    dingdLeix: function () {
      return this.ddlx
    },
    //订单类型
    dingdLeixFw: function () {
      return this.fwddlx
    },
    //服务产品类型
    chanpLx: function () {
      return this.serviceProductsType
    },
    //项目编码
    XmCode: function () {
      return this.xmcode
    }
  },
  props: {
    dialogVisible: {
      type: Boolean,
    },
    usercode: {
      type: String,
    },
    //订单类型
    ddlx: {
      type: String,
    },
    //服务订单类型
    fwddlx: {
      type: String,
    },
    //服务产品类型
    serviceProductsType: {
      type: String,
    },
    oneflag: {
      type: Boolean,
    },
    xmcode: {
      type: String,
    },
    currencyCode: {
      type: String,
    },
    customerChannelCode: {
      type: String,
    },
    country: {
      type: String,
    }
  }
}
</script>

<style>
.xuanzewuliao .el-dialog__header {
  padding-top: 20px;
  padding-left: 20px;
}

.xuanzewuliao .el-dialog__body {
  padding: 20px;
}

.xuanzewuliao .el-table tbody td .cell {
  padding: 0.1rem 0.1rem !important;
}

.xuanzewuliao .h-formbLine .el-form-item__label {
  width: 39%;
}

.xuanzewuliao .h-formbLine .el-form-item__content {
  width: 61%;
}

.xuanzewuliao .yxline .h-formbLine .el-form-item__content {
  width: 61%;
}

.xuanzewuliao .yxline {
  padding-top: 0;
}

.xuanzewuliao .h-pagination {
  padding-top: 0rem;
  padding-bottom: 0rem;
}

.xuanzewuliao .h-rowCon {
  padding-bottom: 0rem;
}

.w-tongyi {
  padding: 0.1rem 0.25rem;
}

/*.el-dialog {*/
/*  width: 1600px;*/
/*}*/
</style>
